<template>
  <div class="container-fluid first-view">
    <img class="logo" :src="logo" />
    <div class="h-100 d-flex flex-row flex-wrap w-100 text-center justify-content-center align-items-center">
      <div
        class="d-flex flex-column custom-margin"
        v-for="route in routes"
        :key="route.content"
      >
        <SelectCard
          :content="route.content"
          :active="route.active"
          :icons="route.icons"
          :title="route.title"
          :route="route.route"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectCard from '@/components/RDFForms/SelectCard'
import logo from '@/assets/images/logos/Iris-Grey.svg'
export default {
  name: 'RDFChoiceView',
  components: {
    SelectCard
  },
  data () {
    return {
      logo,
      routes: [
        {
          title: 'Upload file',
          content: 'Upload a new RDF',
          active: true,
          route: 'rdf_upload',
          icons: ['fa', 'plus']
        },
        {
          title: 'Existing Study',
          content: 'Use an RDF from an existing study',
          active: true,
          route: 'rdf_search',
          icons: ['fa', 'search']
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
.custom-margin {
  margin: 1rem 10rem;
}
.container-fluid.first-view {
  padding: 50px 87px !important;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .background-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #2a274b;
    opacity: 0.4;
  }
  .card {
    width: 90%;
    height: 90%;
  }
}

.logo {
  position: fixed;
  bottom: 75px;
  right: 50px;
  width: 6.5%;
  height: auto;
}

.container-fluid {
  height: 100%;
}

@media screen and (min-width: $break-lg) {
  .custom-margin {
    margin: 1rem 4rem;
  }
}
@media screen and (min-width: $break-xl) {
  .custom-margin {
    margin: 1rem 5rem;
  }
}
@media screen and (min-width: $break-xxl) {
  .custom-margin {
    margin: 1rem 8rem;
  }
}

</style>
